import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { GiPayMoney, GiReceiveMoney } from 'react-icons/gi';

const BadCarSal = ({ saldos, cargos }) => {
    return (
        <div>
            {' '}
            <Row>
                <Col>
                    {saldos.map((sl) => (
                        <div className="alert alert-info " role="alert" key={sl.id}>
                            <div>
                                <span className="font-medium">
                                    <GiPayMoney className="fs-3 mx-2" />
                                    Saldo{' '}
                                    <span className="bg-green text-green-800 text-sm font-medium mr-2 px-2.5 py-0.5 rounded dark:bg-green-900 dark:text-green-300">
                                        ${sl.monto}
                                    </span>
                                </span>{' '}
                                {sl.descri}
                            </div>
                        </div>
                    ))}
                </Col>
                <Col>
                    {cargos.map((cr) => (
                        <div className="alert alert-warning " role="alert" key={cr.id+"cae"}>
                            <div>
                                <span className="font-medium">
                                    <GiReceiveMoney className="fs-3 mx-2" />
                                    Cargo{' '}
                                    <span className="bg-green text-green-800 text-sm font-medium mr-2 px-2.5 py-0.5 rounded dark:bg-green-900 dark:text-green-300">
                                        ${cr.cargo}
                                    </span>
                                </span>{' '}
                                {cr.nota}
                            </div>
                        </div>
                    ))}
                </Col>
            </Row>
        </div>
    );
};

export default BadCarSal;
